import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const unattendedService = {
  list: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.unattendedStudents.list}?${q(params)}`).then(r => r.data)
  },
  approveOrReject: (d: Record<string, unknown>) =>
    restClient.post(endpoints.unattendedStudents.approveOrReject, d).then(r => r.data),
}
